import React, {useState, useEffect} from "react";
import { Box } from "@mui/material";
// import bottomDesign from '../Assets/Dewali_campaign/Bottom_design.png'
import bottomDesign from '../Assets/Dewali_campaign/bottom_design_dark.png'
import topDesign from '../Assets/Dewali_campaign/top_design.png'
import newBg from '../Assets/Dewali_campaign/newBgImg.png'
// import Lamp from '../Assets/Dewali_campaign/Lamp.png'

const DiwaliBackground = ({ children }) => {

     const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imageSrc = bottomDesign;

        const imageSrcTop =
    width < 640
      ? null
      : topDesign;
const smallScreen = width < 640

  return (
    <Box
      sx={{
        minHeight: "100vh",
        // background: "linear-gradient(180deg, #FFEDCD 0%, #F97513 100%)",
        background: 'linear-gradient(to right,rgb(235, 27, 27) 0%,rgb(209, 31, 31) 50%,rgb(222, 54, 54) 100%)',
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: '0%',
          left: 0,
          height: "150px",
          width:'50%',
          maxWidth:'300px',
          background:
             `url(${imageSrcTop}) no-repeat left top / cover`,
        }}
      />

      <Box
        sx={{
            position: "absolute",
            top: "0",
            right: 0,
            height: "150px",
            width: "50%",
            maxWidth:'300px',
            background: `url(${imageSrcTop}) no-repeat right top / cover`,
            transform: "scaleX(-1)", 
            zIndex: 1,
        }}
        />
     
        {smallScreen ?
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height:'100vh',
          background:
            `url(${imageSrc}) no-repeat center bottom / contain`,
        //   opacity: 0.3,
        }}
      />
 :
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height:'200px',
          background:
            `url(${bottomDesign}) no-repeat center bottom / contain`,
        }}
      />
    }
      {children}
    </Box>
  );
};

export default DiwaliBackground;
